import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 定义股票数据接口
interface Stock {
  code?: string;
  name?: string;
  market?: string;
}

// 🆕 为新 ValidationEngine 导出的配置
export const hxKLineValidationConfig: ValidationConfig = {
  fields: [
    // K线图使用特殊的stocks配置，不是标准的字段结构
  ],
  businessRules: [
    {
      name: 'hx-kline-stocks-required',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: Stock[] };
        return Array.isArray(hxKLineLayer.stocks) && hxKLineLayer.stocks.length > 0;
      },
      message: 'K-line chart requires at least one stock configuration',
      suggestion: 'Provide stocks array with at least one valid stock configuration',
      severity: 'error'
    },
    {
      name: 'hx-kline-stock-code-valid',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: Stock[] };
        if (!Array.isArray(hxKLineLayer.stocks)) {
          return true;
        }

        return hxKLineLayer.stocks.every((stock: Stock) => Boolean(stock.code));
      },
      message: 'All stocks must have valid stock codes',
      suggestion: 'Ensure each stock in the stocks array has a valid code property',
      severity: 'error'
    },
    {
      name: 'hx-kline-stock-name-valid',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: Stock[] };
        if (!Array.isArray(hxKLineLayer.stocks)) {
          return true;
        }

        return hxKLineLayer.stocks.every(
          (stock: Stock) => stock.name && typeof stock.name === 'string'
        );
      },
      message: 'All stocks must have valid names',
      suggestion: 'Ensure each stock in the stocks array has a valid name property (string)',
      severity: 'error'
    },
    {
      name: 'hx-kline-optimal-stock-count',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: Stock[] };
        if (!Array.isArray(hxKLineLayer.stocks)) {
          return true;
        }

        return hxKLineLayer.stocks.length <= 10;
      },
      message: 'K-line chart works best with 10 or fewer stocks',
      suggestion: 'Consider limiting to 10 stocks for better performance and readability',
      severity: 'warning'
    }
  ]
};
